import styled from 'styled-components';

export const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  justify-content: space-evenly;
  gap: 20px;

  ${(props) => props.theme.breakpoints.down('md')} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const RecordContainer = styled.div<{
  fontSize?: number;
  color?: string;
}>`
  display: grid;
  justify-content: center;
  margin: 20px 0px;
  font-size: ${(props) => `${props.fontSize ?? 16}px`};
  color: ${(props) => props.color ?? props.theme.palette.text.primary};
`;
